import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/en';
import { translations as esTranslations } from '../translations/es';
import destinationsData from '../data/destinationsData';
import FullBleedImage from '../components/FullBleedImage';
import DestinationCard from '../components/DestinationCard';
import CustomLocationCard from '../components/CustomLocationCard';
import CTASection from '../components/CTASection';
import { Link } from 'react-router-dom';

export default function Destinations() {
  const { language } = useLanguage();
  const t = language === 'en' ? translations : esTranslations;

  const featuredOrder = ['los-cabos', 'cancun-tulum-riviera-maya', 'mexico-city', 'san-miguel-de-allende'];
  const featuredDestinations = featuredOrder.map(slug => destinationsData.find(d => d.slug === slug)).filter(Boolean);
  const additionalLocations = destinationsData.filter(d => 
    !featuredOrder.includes(d.slug)
  );

  return (
    <div className="font-inter bg-white text-[#181c24] min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[48vh] flex items-end overflow-hidden">
        <img
          src="/images/cancun.jpg"
          alt="Destinations"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#181c24]/90 via-[#23283a]/60 to-transparent" />
        <div className="relative z-10 max-w-5xl mx-auto px-6 pb-12 md:pb-20 text-left">
          <h1 className="text-5xl md:text-7xl font-playfair text-white mb-4 drop-shadow-[0_4px_24px_rgba(24,28,36,0.9)] tracking-tight">
            {t.destinations.title}
          </h1>
        </div>
      </section>

      {/* Destination Guides Section */}
      <section className="w-full max-w-7xl mx-auto pt-8 pb-20 md:pt-20 md:pb-20 px-6 md:px-8">
        <h2 className="text-3xl md:text-4xl font-playfair mb-12 text-center">Destination Guides</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {featuredDestinations.map((destination) => (
            <Link
              key={destination.slug}
              to={`/destinations/${destination.slug}`}
              className={`w-full block hover:opacity-90 transition-opacity ${destination.slug === 'los-cabos' ? 'md:col-span-3' : ''}`}
            >
              <DestinationCard destination={destination} language={language} />
            </Link>
          ))}
        </div>

        {/* Additional Locations Section */}
        <h2 className="text-3xl md:text-4xl font-playfair mb-12 text-center">Additional Locations</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {additionalLocations.map((destination) => (
            <div key={destination.slug} className="w-full">
              <DestinationCard destination={destination} language={language} />
            </div>
          ))}
          
          {/* Custom Location Card */}
          <div className={`w-full ${
            additionalLocations.length % 2 === 0 ? 'md:col-span-2' : 'md:col-span-1'
          } ${
            additionalLocations.length % 3 === 0 ? 'lg:col-span-3' : 
            additionalLocations.length % 3 === 1 ? 'lg:col-span-2' : 
            'lg:col-span-1'
          }`}>
            <CustomLocationCard t={t} />
          </div>
        </div>
      </section>

      {/* CTA to Contact Us */}
      <CTASection t={t} />

      {/* Full-bleed image sliver above footer */}
      <FullBleedImage 
        src={destinationsData[0].footerSliverImage}
        alt="Luxury wedding in Mexico"
        className="h-80 md:h-96"
        objectPosition="center 70%"
      />
    </div>
  );
} 